import { useTranslation } from 'react-i18next';
import { mockArticles } from '@/mocks/articles';

interface Props {
  article: typeof mockArticles[0] | undefined;
}

export default function ArticleHero({ article }: Props) {
  const { t } = useTranslation();

  if (!article) return null;

  return (
    <section className="relative w-full h-[380px] md:h-[520px] overflow-hidden">
      <img
        src={article.imageUrl}
        alt={article.title}
        title={article.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/20"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-8 text-center">
        <h1 className="w-full font-heading text-2xl md:text-4xl lg:text-5xl text-background-50 tracking-tight leading-tight max-w-[800px]">
          {article.title}
        </h1>
        <p className="mt-4 max-w-[560px] text-sm text-background-300 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-4 mt-5 text-xs text-background-400">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/30 text-background-50 whitespace-nowrap">
            {article.categoryName}
          </span>
          <span>{article.date}</span>
          <span>{article.views} 阅读</span>
          <span>{article.comments} 评论</span>
        </div>
      </div>
    </section>
  );
}